import { Injectable } from '@angular/core';
import { BehaviorSubject, Subscription, throwError, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

// INTERFACES
import { IPermission } from '../../../rbac/interfaces/rbac.interface';

// SERVICES
import { EnvironmentUtilService } from '../util';

import { ApiService } from './api.service';
@Injectable({
  providedIn: 'root',
})
export class RbacApiService {
  private readonly _loading = new BehaviorSubject<boolean>(<boolean>false);
  private readonly _permissions = new BehaviorSubject<IPermission[]>(
    <IPermission[]>[],
  );

  loading$ = this._loading.asObservable();

  environment = this.environmentUtilService.getEnvironment();

  constructor(
    private apiService :ApiService,
    private environmentUtilService :EnvironmentUtilService,
  ) {}

  get() :Subscription {
    this._loading.next(true);

    return this.apiService
      .get(`${this.environment.urlV1}/rbac/my-permissions`)
      .subscribe({
        next: (response :any) => {
          this._loading.next(false);
        },
        error: (error) => throwError(() => new Error(error)),
      });
  }
}
